<template>
  <header class="mb-2 pl-2 pr-2">
    <div class="flex">
      <div
        v-if="icon"
        ref="icon"
        class="text-center flex-initial text-3xl pr-4"
        :class="iconClasses"
      >
      <font-awesome-icon icon="fa-newspaper" />
      </div>

      <div>
        <a :href="link" target="_blank">
          <span ref="title" :class="titleClasses">
            <p>{{ title }}</p>
          </span>
        </a>
        <p ref="pubDate" class="">{{ formatDate(pubDate) }}</p>
      </div>
    </div>
  </header>
</template>

<script>
import moment from "moment"

export default {
  name: "NewsCardHeader",
  props: {
    title: {
      required: true,
      type: String,
    },
    pubDate: {
      required: true,
      type: String,
    },
    type: {
      required: true,
      type: String,
    },
    link: {
      required: false,
      type: String,
    },
  },
  methods: {
    /**
     * Formats a date for display.
     *
     * @param {String} rawDate - datetime in 8601 format
     *
     * @returns {String} formatted date (example: September 12, 2020)
     */
    formatDate: function(rawDate) {
      let date = moment(String(rawDate))
      if (date.isValid()) {
        return date.format("MMMM DD, YYYY")
      }
      return ""
    },
  },
  computed: {
    /**
     * Generates the classes for news item icon
     *
     * @returns associated classes
     */
    iconClasses() {
      if (this.type == "twitter") {
        return "text-blue-twitter"
      }
      return "text-dark-blue-500"
    },
    /**
     * Generates the classes for the news item title
     *
     * @returns associated classes
     */
    titleClasses() {
      if (this.type == "twitter") {
        return "text-base"
      }
      return "text-gray-900 font-bold text-lg"
    },
    /**
     * Get the icon for a news item type
     *
     * @returns icon name/class
     */
    icon() {
      switch (this.type) {
        case "newsReleases":
          return "fa fa-newspaper"
        case "twitter":
          return "fab fa-twitter"
        default:
          return null
      }
    },
  },
}
</script>
